import React from 'react'
import MonoHeader from '../Header/MonoHeader'
import MenuPrice from './MenuPrice'
import MonoKiosk from './MonoKiosk'
import MonoFooter from './MonoFooter'

import styled from 'styled-components'

const DuoKioskWrapper = styled.div`
    display: flex;
    flex-direction: row;
`

const DuoKiosk = props => {
    const {
        useCommercialName,
        hideComposition,
        hideLabels,
        hideIntolerences,
        dataSource,
        isAdministrationPanel,
        language,
        hideMenuPrice,
        hideRecipePoints,
        hideEnergyKcal,
        showEnergyKcalByPortion
    } = props

    let isKiosksEmpty = true
    if (props.items.kiosks && props.items.kiosks.length) {
        props.items.kiosks.map(kiosk => {
            if (kiosk.items.length) {
                isKiosksEmpty = false
            }
        })
    }

    if (isKiosksEmpty) {
        return (
            <Grid>
                <img
                    style={{ maxWidth: '100%' }}
                    src={`img/no_menu_${language}.png`}
                />
            </Grid>
        )
    }

    return (
        <DuoKioskWrapper>
            {props.items.kiosks.slice(0, 2).map((kiosk, index) => (
                <div style={{ flex: 1 }}>
                    <MonoHeader
                        style={{ flex: 1 }}
                        menu={props.menu}
                        concept={props.concept}
                        monoKioskPicture={kiosk.kioskPicture}
                    />
                    <MonoKiosk
                        defaultColumnsCount={1}
                        items={kiosk.items}
                        kioskPicture={kiosk.kioskPicture}
                        zoom={props.zoom}
                        key={index}
                        currency={props.currency}
                        useCommercialName={useCommercialName}
                        dataSource={dataSource}
                        hideComposition={hideComposition}
                        hideLabels={hideLabels}
                        hideIntolerences={hideIntolerences}
                        hideMenuPrice={hideMenuPrice}
                        hideRecipePoints={hideRecipePoints}
                        hideEnergyKcal={hideEnergyKcal}
                        showEnergyKcalByPortion={showEnergyKcalByPortion}
                    />
                    {/* <MonoFooter
                        kiosk={kiosk.kioskPicture}
                        style={{
                            backgroundImage: `url(img/concept/${props.concept}/kiosk/${kiosk.kioskPicture}/mono-footer.png)`,
                        }}
                    /> */}
                    <MonoFooter kiosk={kiosk.kioskPicture} />
                </div>
            ))}
        </DuoKioskWrapper>
    )
}

export default DuoKiosk
